function readCtxFromRouter(router) {
  const q = router?.query || {};
  return {
    shop: typeof q.shop === "string" ? q.shop : "",
    host: typeof q.host === "string" ? q.host : "",
    embedded: typeof q.embedded === "string" ? q.embedded : "",
    shopify_variant: typeof q.shopify_variant === "string" ? q.shopify_variant : "",
    variant: typeof q.variant === "string" ? q.variant : "",
  };
}

function readCtxFromWindow() {
  if (typeof window === "undefined") {
    return { shop: "", host: "", embedded: "", shopify_variant: "" };
  }
  const p = new URLSearchParams(window.location.search);
  return {
    shop: p.get("shop") || "",
    host: p.get("host") || "",
    embedded: p.get("embedded") || "",
    shopify_variant: p.get("shopify_variant") || "",
    variant: p.get("variant") || "",
  };
}

export function withShopifyCtx(path, router) {
  const raw = String(path || "").trim();
  if (!raw || !raw.startsWith("/")) return raw;
  if (raw.startsWith("/api/")) return raw;

  const base = typeof window !== "undefined" ? window.location.origin : "https://afivio.com";
  const url = new URL(raw, base);

  const fromRouter = readCtxFromRouter(router);
  const fromWindow = readCtxFromWindow();
  const shop = fromRouter.shop || fromWindow.shop;
  const host = fromRouter.host || fromWindow.host;
  const variant =
    fromRouter.shopify_variant ||
    fromWindow.shopify_variant ||
    fromRouter.variant ||
    fromWindow.variant;
  const embedded = fromRouter.embedded || fromWindow.embedded || (shop || host ? "1" : "");

  if (!url.searchParams.get("shop") && shop) url.searchParams.set("shop", shop);
  if (!url.searchParams.get("host") && host) url.searchParams.set("host", host);
  if (!url.searchParams.get("embedded") && embedded) url.searchParams.set("embedded", embedded);
  if (!url.searchParams.get("shopify_variant") && variant) url.searchParams.set("shopify_variant", variant);

  return `${url.pathname}${url.search}${url.hash}`;
}
